import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_down",
  "use": "icon-arrow_down-usage",
  "viewBox": "0 0 13 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 8\" id=\"icon-arrow_down\">\n  <!-- Цвет убрал, чтобы работал svg-load -->\n  <path d=\"M2186.55,1444.99l1.44,1.46-5.05,5.08h0l-1.44,1.46-1.44-1.46h0l-5.05-5.08,1.44-1.46,5.05,5.09Z\" transform=\"translate(-2175 -1445)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol